import React, { memo } from 'react';

import isEqual from 'lodash/isEqual';

import { Grid, Button } from '@gogame/components';
import { withArrayFormField } from '@gogame/form';

import { useLoadTargets } from 'scenes/Integrations/data';

import { REQUEST_URL } from '../constants';
import { postbackStrategySchema } from '../schemas';
import { Strategy } from './Strategy';

const Strategies = withArrayFormField({
  validationSchema: postbackStrategySchema,
})(({ value, push, remove }) => {
  const handleAddStrategy = React.useCallback(() => {
    push(postbackStrategySchema.default());
  }, [push]);

  const handleCopyStrategy = React.useCallback(
    (strategy) => {
      push(postbackStrategySchema.cast(strategy));
    },
    [push]
  );

  const { data: targets } = useLoadTargets();

  return (
    <>
      <Grid item xs={12}>
        <Button add color={'primary'} onClick={handleAddStrategy}>
          Strategy
        </Button>
      </Grid>
      {value?.map((strategy, index) => (
        <Strategy
          strategy={strategy}
          onCopyStrategy={handleCopyStrategy}
          index={index}
          remove={remove}
          value={value}
          targets={targets}
          isEditMode={value?.length <= 10 || !strategy?.[REQUEST_URL]?.length}
        />
      ))}
    </>
  );
});

export default memo(Strategies, isEqual);
